import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Stack } from "@mui/material";
import SearchResultGrid from "../searchResultGrid/searchResultGrid";
import apiClient from "../../axiosClient";
// Custom types and defs
import agentColumnDef from "./colDef/agentConfig";
import Agent from "./interface/agent";
import AddAgentModal, { NewAgentRequest } from "./modal/addAgent";
import { apiCallWrapper } from "../../utils/commonUtils";

interface AgentConfigComponentProp {
	loading: boolean,
	agents: Agent[],
	refresh: () => void
}

const AgentConfig: React.FC<AgentConfigComponentProp> = ({ loading, agents, refresh }) => {
	const [openAddAgentModal, setAddAgentModalVisibility] = useState<boolean>(false);

	const createAgents = async (agents: NewAgentRequest[]) => {
		const response = await apiCallWrapper(() => apiClient.post(`/api/v1/tcn_config/agent`, agents));
		if (response && (response.status === 200 || response.status === 201)) {
			alert("Agents added successfully");
			refresh();
			setAddAgentModalVisibility(false);
		}
	}

	return (
		<Box sx={{ margin: '10px', display: 'flex', flexDirection: 'column' }}>

			<Stack
				direction="row"
				spacing={2}
				justifyContent="flex-end"
				sx={{ mb: 2 }}
			>
				<Button variant="contained" onClick={() => setAddAgentModalVisibility(true)}>Add Agent</Button>
			</Stack>

			{loading ? (
				<Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
					<CircularProgress />
				</Box>
			) : (
				<SearchResultGrid
					columns={agentColumnDef}
					results={agents}
					rowCount={agents.length}
					onSelectRow={() => { }}
					getRowId={(row: Agent) => row.agent_id}
					disableFilter={false}
					disableSorting={false}
				/>
			)}

			{openAddAgentModal ? <AddAgentModal open={openAddAgentModal} onClose={() => setAddAgentModalVisibility(false)} onSubmit={(agents: NewAgentRequest[]) => createAgents(agents)} /> : null}
		</Box>
	);
};

export default AgentConfig;